$(function() {
   // Check if we're on a recalls page by looking for recall-specific elements
   if ($('.sk-recall').length) {
      // Initialize date input - use native HTML5 date input
      const initDateInput = function() {
         $('#date-recall').mask('00/00/0000'); //using as a fallback incase the datepicker is not loading.

         datepicker('#date-recall', {
            maxDate: new Date(),
            customDays: [window.theme.custom.global.days.sun, window.theme.custom.global.days.mon, window.theme.custom.global.days.tue, window.theme.custom.global.days.wed, window.theme.custom.global.days.thu, window.theme.custom.global.days.fri, window.theme.custom.global.days.sat],
            customMonths: [window.theme.custom.global.months.january.full, window.theme.custom.global.months.february.full, window.theme.custom.global.months.march.full, window.theme.custom.global.months.april.full, window.theme.custom.global.months.may.full, window.theme.custom.global.months.june.full, window.theme.custom.global.months.july.full, window.theme.custom.global.months.august.full, window.theme.custom.global.months.september.full, window.theme.custom.global.months.october.full, window.theme.custom.global.months.november.full, window.theme.custom.global.months.december.full],
            customOverlayMonths: [window.theme.custom.global.months.january.abbr, window.theme.custom.global.months.february.abbr, window.theme.custom.global.months.march.abbr, window.theme.custom.global.months.april.abbr, window.theme.custom.global.months.may.abbr, window.theme.custom.global.months.june.abbr, window.theme.custom.global.months.july.abbr, window.theme.custom.global.months.august.abbr, window.theme.custom.global.months.september.abbr, window.theme.custom.global.months.october.abbr, window.theme.custom.global.months.november.abbr, window.theme.custom.global.months.december.abbr],
            overlayPlaceholder: window.theme.custom.global.four_digit_year,
            overlayButton: window.theme.custom.global.submit,
            formatter: (input, date, instance) => {
               const dd = String(date.getDate()).padStart(2, '0');
               const mm = String(date.getMonth() + 1).padStart(2, '0');
               const yyyy = date.getFullYear();
               input.value = mm + '/' + dd + '/' + yyyy; //BV wants this as mmddyy
            },
            onHide: instance => {
               $("#recall-form").validate().element(instance.el);
            }
         });
      };

      // Initialize select menu
      const initSelectMenu = function() {
         $('#state-recalls')
            .change(function () {
               $(this).selectmenu("refresh");
            })
            .selectmenu({
               classes: {
                  "ui-selectmenu-menu": "ego-recalls-ui-select-menu"
               },
               change: function () {
                  $("#recall-form").validate().element(this);
               }
            });
      };

      // Initialize all components
      initDateInput();
      initSelectMenu();
   }
});